import firebase from '../../src/config/firebase';
require('firebase/auth')


const driverService = {
    

    async getDriverAvailable(id){
        
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .get()
    },
    
    async getDriverAvailableById(id){
        // console.log("getDriverAvailableById: " + id)
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .collection('documents')
            .doc("allData")
            .get()
    },

    async getDriverAllByUID(uid) {
        const driverQuerySnapshot = await firebase.firestore()
            .collection('drivers_users')
            .where("uid", "==", uid)
            .get();

        if (driverQuerySnapshot.empty) {
            throw new Error("Motorista não encontrado.");
        }

        // Assumindo que o uid é único, pegue o primeiro documento
        const driverDoc = driverQuerySnapshot.docs[0];
        
        // Agora acesse a subcoleção "documents"
        const allDataDoc = await driverDoc.ref
            .collection('documents')
            .doc('allData')
            .get();

        if (!allDataDoc.exists) {
            throw new Error("Documento 'allData' não encontrado.");
        }

        return {
            driverData: driverDoc.data(),
            allData: allDataDoc.data()
        };
    },

    async getDriverDocuments(id) {
        return firebase.firestore()
            .collection('drivers_users')
            .doc(id)
            .collection('documents')
            .get();
    },

    async getDriverDocumentsUID(uid) {
        return firebase.firestore()
            .collection('drivers_users')
            .where("uid", "==", uid)
            .get();
    },

    async getAllDriver(idShipper){

        const collectionRef = firebase.firestore()
            .collection('drivers_users')
            .where("uidShipper", "==", idShipper)
            .get();
        var count = await collectionRef;
        return count.size;

    },
    async getAllDriverr(){

        const collectionRef = firebase.firestore()
            .collection('drivers_users')
            .get();
        return collectionRef;

    },

    async updateDriverUidShipper(uidDriver, uidShipperFreight, previousUidShipperDriver) {

        // Normaliza previous em array plano
        const previous = Array.isArray(previousUidShipperDriver)
            ? previousUidShipperDriver.flat()
            : (typeof previousUidShipperDriver === "string"
                ? [previousUidShipperDriver]
                : []);

        // Busca o documento do driver
        const snapshot = await firebase.firestore()
            .collection('drivers_users')
            .doc(uidDriver)
            .collection('documents')
            .get();

        if (snapshot.empty) {
            throw new Error("Driver não encontrado");
        }

        const docSnap = snapshot.docs[0];
        const docRef = docSnap.ref;
        const data = docSnap.data();

        // Normaliza currentUid
        let currentUid = [];

        if (Array.isArray(data.shipper?.uid)) {
            currentUid = data.shipper.uid.flat();
        } else if (typeof data.shipper?.uid === "string") {
            currentUid = [data.shipper.uid];
        }

        // Junta tudo num array único e sem duplicados
        const newUidShipper = Array.from(
            new Set([
                ...currentUid,
                ...previous,
                uidShipperFreight
            ])
        );

        // Atualiza no Firestore
        await docRef.update({
            "shipper.uid": newUidShipper
        });
    },

    async getDriverByCPF(cpf) {
        const cpfClean = cpf.replace(/\D/g, '');

        const snapshot = await firebase.firestore()
            .collection('drivers_users')
            .where('cpf', 'in', [cpf, cpfClean])
            .get();

        if (snapshot.empty) return [];

        return snapshot.docs.map(doc => ({ driverId: doc.id, ...doc.data() }));
    },

    async saveMyFreightToDriver(idDriver, data){
        console.log("Adicionando o frete ao motorista " + data)

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .add(data)
            // .doc(idFreight)
            // .update(data)
            .catch(error => {
                console.log(error)
            });
    },


    async saveStatusMyFreight(idDriver, idFreight, status){
        console.log("salvando status na fila do MyFrete" + status)

        var data = {
            status: status
        }

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight)
            .update(data)
            .catch(error => {
                console.log(error)
            });
    },

    async saveMyFreight(idDriver, idFreight, data){
        console.log("salvando status na fila do MyFrete")

        console.log(data)

        // Deletar o documento existente antes de salvar
        try {
            await firebase.firestore()
                .collection('drivers_users')
                .doc(idDriver)
                .collection('myFreightsList')
                .doc(idFreight)
                .delete();
        } catch (error) {
            // Ignora erro se o documento não existir
            console.log("Não é documento para deletar:", error);
        }

        // Salvar o novo documento
        firebase.firestore()
                .collection('drivers_users')
                .doc(idDriver)
                .collection('myFreightsList')
                .doc(idFreight)
                .set(data)
            .catch(error => {
                console.log(error)
            });
    },

    async saveClient(clientData) {

        try {
            await firebase.firestore()
                .collection("client")
                .doc()
                .set(clientData);
    
            // alert("Dados atualizados com sucesso!");
        } catch (error) {
            console.error("Erro ao adicionar dados:", error);
        }
    },

    async saveMessageInMyFreight(idDriver, title, message){
        console.log("salvando mensagens na fila do MyFrete ")
        // salvar em drivers_users/uidUser/notifications
        var data = {
            title: title,
            message: message,
            created: new Date()
        }

        console.log(data)

        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('notifications')
            .add(data)
            .catch(error => {
                console.log(error)
            });

    },


    async deleteStatusMyFreight(idDriver, idFreight){
        console.log("Deletando status na fila do MyFrete")
        
        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight)
            .delete()
            .catch(error => {
                console.log(error) 
            });

    },


    async deleteDriverAllStatusMyFreight(idDriver, idFreight){
        console.log("Deletando status na fila do MyFrete")
        
        firebase.firestore()
            .collection('drivers_users')
            .doc(idDriver)
            .collection('myFreightsList')
            .doc(idFreight)
            .delete()
            .catch(error => {
                console.log(error) 
            });

    },



}

export default driverService;